import { format } from 'date-fns';

export default function FormattedDate({ date }: { date: string | Date }) {
  if (!date) return <></>;
  return <>{format(date, 'MMMM dd, yyyy')}</>;
}
